/* eslint-disable max-len */
/* eslint no-nested-ternary: 0 */
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Button,
  Divider,
  Form as SemanticForm,
  Grid,
  Header,
  Label,
  Segment,
  Icon,
} from 'semantic-ui-react';
import { Trans, withTranslation } from 'react-i18next';
import { required, numericRange } from '@mhub/web-validations';

import Delete from './Delete';
import List from './List';
import New from './New';

import AppForm from '../../components/AppForm';
import CurrencySymbol from '../../components/CurrencySymbol';
import LoanAmount from '../../components/LoanAmount';
import TotalAmountModal from './TotalAmountModal';
import { StateAuth } from '../../types';

import { centsToFloat } from '../../utils/numbers/centsFloat';
import { validateForm } from '../../utils/validations';
import { translateModels } from '../../utils/translation';
import {
  depositLabel,
  hasVietnamElevatedAccess,
  isVietnamCompany,
  vnDepositStatusLabel,
} from '../../utils/vietnam';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

class BookingPayment extends Component {
  static propTypes = {
    auth: StateAuth,
    checkChanges: PropTypes.func,
    disabled: PropTypes.bool,
    defaultBookingFeeAmount: PropTypes.number,
    fetchNewBooking: PropTypes.func,
    resetChanges: PropTypes.func,
    token: PropTypes.string,
    updateBookingPayment: PropTypes.func,
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static defaultBookingPayment = {
    bookingID: '',
    paymentTypeID: '',
    paymentType: {
      name: '',
    },
    paymentStatusID: '',
    paymentAmount: '',
    paymentPictures: [],
    paymentAt: '',
    paymentReference: '',
    paymentNotes: '',
    bookingFeeDeductiblePaymentPlan: false,
    project: {
      projectCurrency: null,
    },
  };
  static getPropsToState = (props) => {
    const data = Object.assign({}, BookingPayment.defaultBookingPayment, props.data);
    const projectCurrencies = data.project.projectCurrency;
    const isEditBookingPayment = parseFloat(props.data.paymentAmount || 0) <= 0;
    const hasPaymentMade = props.data.bookingFeePayments &&
    props.data.bookingFeePayments.length > 0;
    return {
      data,
      hasPaymentMade,
      isCancelTransaction: false,
      isEditBookingFeePayment: false,
      isEditBookingPayment,
      paymentAmountMoreThanZero: parseFloat(props.data.paymentAmount) > 0,
      paymentToBeCancel: {},
      oriData: Object.assign({}, props.data),
      projectCurrencies,
    };
  }
  constructor(props) {
    super(props);
    const state = BookingPayment.getPropsToState(props);
    this.validation = {
      paymentAmount: createRef(),
    };
    this.state = {
      ...state,
      openTotalAmount: false,
      hasChanged: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = BookingPayment.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  onCancelTransaction = (paymentId) => {
    const { data } = this.state;
    const paymentToBeCancel = data.bookingFeePayments.find(e => e.id === paymentId);
    if (paymentToBeCancel) {
      this.setState({
        isCancelTransaction: true,
        paymentToBeCancel,
      });
    }
  }
  setNewPaymentBgColor() {
    const { paymentAmountMoreThanZero } = this.state;
    return paymentAmountMoreThanZero ? '#E8F3FA' : '#E5E5E5';
  }
  setNewPaymentButtonColor() {
    const { paymentAmountMoreThanZero } = this.state;
    return paymentAmountMoreThanZero ? 'blue' : 'grey';
  }
  setPaymentStatusColor = (paymentStatus) => {
    if (paymentStatus.id === 'paid') return 'green';
    return 'grey';
  }
  isShowCancelButton() {
    const { isEditBookingPayment, paymentAmountMoreThanZero } = this.state;
    return isEditBookingPayment && paymentAmountMoreThanZero;
  }
  handlePaymentUpdated = async () => {
    if (this.props.fetchNewBooking) await this.props.fetchNewBooking();
  }
  handleInputChange = (event, { name, value }) => {
    event.preventDefault();
    if (this.props.checkChanges) this.props.checkChanges('isBookingPaymentChanged');
    const { data } = this.state;
    data[name] = value;
    if (value > 0 || value === '') {
      this.setState({ hasChanged: true });
    }
    this.setState({ data });
  }
  handleCheckBoxChange = (event, { name }) => {
    event.preventDefault();
    if (this.props.checkChanges) this.props.checkChanges('isBookingPaymentChanged');
    const { data } = this.state;
    data[name] = !data[name];
    this.setState({ hasChanged: true, data });
  }
  handleResetInputChange = (sectionName = 'BookingPayment') => {
    const { oriData } = this.state;
    const stateToUpdate = {
      [`isEdit${sectionName}`]: false,
      data: oriData,
    };
    this.setState(stateToUpdate, () => {
      if (this.props.resetChanges) this.props.resetChanges(`is${sectionName}Changed`);
    });
  }
  handleResetTransaction = () => {
    this.setState({
      isCancelTransaction: false,
      paymentToBeCancel: {},
    });
    this.handleResetInputChange('BookingFeePayment');
  }
  handleSaveBookingPayment = (e) => {
    e.preventDefault();
    const { store } = this.context;
    const { paymentAmount, paymentNotes, bookingFeeDeductiblePaymentPlan } = this.state.data;
    return AppForm.validate(this.validation, this.state.data)
      .then((validations) => {
        if (validateForm(store, validations)) return;
        this.props.updateBookingPayment({
          paymentAmount: parseFloat(paymentAmount),
          paymentNotes,
          bookingFeeDeductiblePaymentPlan,
        });
        if (this.props.resetChanges) this.props.resetChanges('isBookingPaymentChanged');
        this.setState({ isEditBookingPayment: false });
      });
  }
  handleSetState(state = {}) {
    this.setState(state);
  }
  handleOnClose = () => {
    this.setState({ openTotalAmount: false });
  }
  showTotalAmount = (e) => {
    e.preventDefault();
    this.setState({ openTotalAmount: true });
  }
  hasPaymentActionAccess(hasAccess, maUserID, statusID) {
    const auth = this.props.auth;
    if (!auth.companyBranch.isExternal) {
      return true;
    }
    if (hasAccess &&
      auth.companyBranch.isExternal &&
      statusID === 'reserved'
    ) {
      if (auth.isExternalAgentLeader) {
        return true;
      } else if (maUserID === auth.id) {
        return true;
      }
    }
    return false;
  }
  // CPI-974 (D5): Vietnam restricts cancelling a deposit to the SA / HQ family.
  hasDepositCancelAccess() {
    return hasVietnamElevatedAccess(this.props.auth);
  }
  // MS-6329: production's payment-proof deletion gate. Kept alongside the Vietnam gate above
  // so Malaysia behaves exactly as master does.
  hasPaymentDeleteAccess() {
    const { auth } = this.props;
    return auth && (
      auth.isSuperAdmin ||
      auth.isAdminBasic ||
      auth.isHeadquarters ||
      auth.isDeveloperSupervisor ||
      auth.isDeveloperSalesManager ||
      auth.isDeveloperSalesAdmin
    );
  }
  renderPaymentSection() {
    const {
      data,
      oriData,
      hasPaymentMade,
      isCancelTransaction,
      isEditBookingFeePayment,
      paymentAmountMoreThanZero,
      paymentToBeCancel,
      projectCurrencies } = this.state;
    const { auth, t } = this.props;
    const projectBankAccount = data.project.projectBankAccount || [];

    const newSection = (<New
      bookingData={this.state.data}
      projectBankAccount={projectBankAccount}
      onUpdated={this.handlePaymentUpdated}
      defaultObj={BookingPayment.defaultBookingPayment}
      checkChanges={this.props.checkChanges}
      resetChanges={this.handleResetInputChange}
      token={this.props.token}
    />);

    if (!hasPaymentMade) {
      return (
        <span>
          {
            isEditBookingFeePayment ? (
              newSection
            ) : (
              <div
                className="content-centered"
                style={{ backgroundColor: this.setNewPaymentBgColor(), borderRadius: '10px' }}
              >
                <Button
                  className="booking-new-payment-button"
                  size="large"
                  color={this.setNewPaymentButtonColor()}
                  disabled={!paymentAmountMoreThanZero || this.props.disabled || !this.hasPaymentActionAccess(oriData.project && oriData.project.allowAgentChangeBookingPaymentMethod, oriData.maUserID, oriData.statusID)}
                  onClick={() => {
                    this.handleSetState({ isEditBookingFeePayment: true });
                  }}
                  content={depositLabel(auth, t, 'New Payment')}
                />
              </div>
            )
          }
        </span>
      );
    }
    if (isCancelTransaction) {
      return (
        <Delete
          checkChanges={this.props.checkChanges}
          data={paymentToBeCancel}
          onUpdated={this.handlePaymentUpdated}
          projectBankAccount={projectBankAccount}
          projectCurrencies={projectCurrencies}
          resetChanges={this.handleResetTransaction}
          token={this.props.token}
        />
      );
    }
    if (hasPaymentMade) {
      return (
        <div>
          {
            isEditBookingFeePayment ? (
              newSection
            ) : (
              <div style={{ textAlign: 'center' }}>
                <Button
                  color="blue"
                  onClick={() => {
                    this.handleSetState({ isEditBookingFeePayment: true });
                  }}
                  content={depositLabel(auth, t, 'Add Payment')}
                  disabled={!this.hasPaymentActionAccess(oriData.project && oriData.project.allowAgentChangeBookingPaymentMethod, oriData.maUserID, oriData.statusID)}
                />
                <Divider hidden />
                <List
                  auth={auth}
                  data={data}
                  hideCancel={isVietnamCompany(auth) ?
                    !this.hasDepositCancelAccess() :
                    (!this.hasPaymentDeleteAccess() ||
                      !this.hasPaymentActionAccess(oriData.project && oriData.project.allowAgentCancelBookingFee, oriData.maUserID, oriData.statusID))}
                  onUpdated={this.handlePaymentUpdated}
                  onCancelTransaction={this.onCancelTransaction}
                  projectBankAccount={projectBankAccount}
                  token={this.props.token}
                />
              </div>
            )
          }
        </div>
      );
    }
    return null;
  }
  render() {
    const {
      data,
      isEditBookingPayment,
      oriData,
      projectCurrencies,
      hasChanged } = this.state;
    const { auth, defaultBookingFeeAmount = 0, t } = this.props;
    return (
      <div>
        <Header className="new_title" as="h5" attached="top" textAlign="center">
          {t('Payment').toUpperCase()}
        </Header>
        <Segment attached>
          <Grid>
            <Grid.Row>
              <Grid.Column mobile={16} tablet={8} computer={8}>
                <Grid>
                  { isEditBookingPayment ?
                    <Grid.Column textAlign="left" width={11}>
                      { isVietnamCompany(auth) ? (
                        <Trans ns={TRANSLATION_FILES.screens} components={{ b: <strong /> }}>
                          Key in <b>total amount</b> of deposit required
                        </Trans>
                      ) : (
                        <Trans ns={TRANSLATION_FILES.screens} components={{ b: <strong /> }}>
                          Key in <b>total amount</b> of booking fee deposit required
                        </Trans>
                      )}
                      .&nbsp;
                      <Button onClick={this.showTotalAmount} style={{ opacity: 1, color: 'black' }} className="flash-button">
                        <Icon
                          name="info circle"
                        />
                      </Button>
                    </Grid.Column> : null
                  }
                  { isEditBookingPayment ?
                    <Grid.Column textAlign="right" width={5}>
                      {
                        oriData.paymentStatus ? (
                          <Label
                            circular
                            color={this.setPaymentStatusColor(oriData.paymentStatus)}
                            horizontal
                          >
                            {vnDepositStatusLabel(auth, t, oriData.paymentStatus.id) ||
                              t(oriData.paymentStatus.name, { ns: TRANSLATION_FILES.constants })}
                          </Label>
                        ) : null
                      }
                    </Grid.Column> : null
                  }
                  <Grid.Column textAlign="right">
                    {
                      (isEditBookingPayment || this.props.disabled || !this.hasPaymentActionAccess(oriData.project && oriData.project.allowAgentEditBookingFee, oriData.maUserID, oriData.statusID)) ? null :
                      (
                        <Label
                          as="button"
                          attached="top right"
                          size="small"
                          content={t('Edit', { ns: TRANSLATION_FILES.translation })}
                          icon="edit"
                          onClick={() => {
                            this.handleSetState({ isEditBookingPayment: true });
                          }}
                          className={'editable-button'}
                        />
                      )
                    }
                  </Grid.Column>
                </Grid>
                { isEditBookingPayment ? null :
                <Grid>
                  <Grid.Column textAlign="right">
                    {
                      oriData.paymentStatus ? (
                        <Label
                          circular
                          color={this.setPaymentStatusColor(oriData.paymentStatus)}
                          horizontal
                        >
                          {vnDepositStatusLabel(auth, t, oriData.paymentStatus.id) ||
                            t(oriData.paymentStatus.name, { ns: TRANSLATION_FILES.constants })}
                        </Label>
                      ) : null
                    }
                  </Grid.Column>
                </Grid>
                }
                <TotalAmountModal
                  open={this.state.openTotalAmount}
                  onClose={this.handleOnClose}
                />
                <Grid verticalAlign="middle">
                  <Grid.Column textAlign="left" width={8}>
                    <b>
                      {
                        depositLabel(auth, t, isEditBookingPayment ? 'Booking Fee Amount' : 'Booking Fee')
                      }
                    </b>
                  </Grid.Column>
                  <Grid.Column textAlign="right" width={8}>
                    {
                      isEditBookingPayment ?
                        <AppForm
                          onSubmit={this.handleSaveBookingPayment}
                        >
                          <AppForm.Input
                            disabled={this.props.disabled}
                            hideMessage
                            validateLabel={t('Amount')}
                            placeholder={defaultBookingFeeAmount.toString()}
                            name="paymentAmount"
                            value={
                              data.paymentAmount === 0 || '' ?
                              (hasChanged ? data.paymentAmount : defaultBookingFeeAmount)
                              : data.paymentAmount
                            }
                            onChange={this.handleInputChange}
                            ref={this.validation.paymentAmount}
                            validation={oriData.paymentPaidCents !== 0 ? [required, {
                              validate: numericRange,
                              option: {
                                min: 1,
                              },
                            }] : [{
                              validate: numericRange,
                              option: {
                                min: 0,
                              },
                            }]}
                            type="number"
                          />
                        </AppForm>
                      : (
                          oriData.paymentAmount ?
                            <LoanAmount
                              projectCurrencies={projectCurrencies}
                              format="0,000,000.00"
                              amount={oriData.paymentAmount}
                              prefix={<CurrencySymbol />}
                            />
                          : '-'
                        )
                    }
                  </Grid.Column>
                </Grid>
                {
                  isEditBookingPayment ? null : (
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={8}>
                        <b>{t('Payments Made')}</b>
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        <LoanAmount
                          projectCurrencies={projectCurrencies}
                          format="0,000,000.00"
                          amount={centsToFloat(oriData.paymentPaidCents)}
                          prefix={<CurrencySymbol />}
                        />
                      </Grid.Column>
                    </Grid>
                  )
                }
                {
                  isEditBookingPayment ? null : (
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={8}>
                        <b>{t('Outstanding')}</b>
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        {
                          oriData.paymentAmount ?
                            <LoanAmount
                              projectCurrencies={projectCurrencies}
                              format="0,000,000.00"
                              amount={oriData.paymentAmount - centsToFloat(oriData.paymentPaidCents)}
                              prefix={<CurrencySymbol />}
                            />
                          : '-'
                        }
                      </Grid.Column>
                    </Grid>
                  )
                }
                {
                  isEditBookingPayment ? null : (
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={8}>
                        <b>{translateModels(t, 'bookingFeeDeductiblePaymentPlan', 'booking')}</b>
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        {t(oriData.bookingFeeDeductiblePaymentPlan ? 'Yes' : 'No', { ns: TRANSLATION_FILES.constants })}
                      </Grid.Column>
                    </Grid>
                  )
                }
                {
                  isEditBookingPayment ? (
                    <Grid verticalAlign="middle">
                      <Grid.Column textAlign="left" width={8}>
                        <b>{t('Notes')}</b>
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        <SemanticForm.Input
                          fluid
                          name="paymentNotes"
                          onChange={this.handleInputChange}
                          placeholder={t('Notes')}
                          value={data.paymentNotes}
                          disabled={this.props.disabled}
                        />
                      </Grid.Column>
                    </Grid>
                  ) : (
                    <Grid verticalAlign="middle">
                      <hr style={{ width: '90%', textAlign: 'right', margin: '0 auto' }} />
                      <Grid.Column style={{ paddingTop: '1px' }} textAlign="left" width={16}>
                        <span style={{ color: '#808080' }}>{oriData.paymentNotes || '-'}</span>
                      </Grid.Column>
                    </Grid>
                  )
                }
                {
                  isEditBookingPayment ? (
                    <Grid verticalAlign="middle">
                      <SemanticForm.Checkbox
                        name="bookingFeeDeductiblePaymentPlan"
                        label={translateModels(t, 'bookingFeeDeductiblePaymentPlan', 'booking')}
                        onChange={this.handleCheckBoxChange}
                        checked={data.bookingFeeDeductiblePaymentPlan}
                        disabled={this.props.disabled}
                      />
                    </Grid>
                  ) : null
                }

                <Grid verticalAlign="middle">
                  <Grid.Column textAlign="left" only="tablet computer" tablet={6} computer={8} />
                  <Grid.Column textAlign="right" mobile={16} tablet={5} computer={4}>
                    {
                      this.isShowCancelButton() ? (
                        <Button
                          fluid
                          onClick={() => {
                            this.handleResetInputChange('BookingPayment');
                          }}
                          basic
                          content={t('Cancel', { ns: TRANSLATION_FILES.translation })}
                        />
                      ) : null
                    }
                  </Grid.Column>
                  <Grid.Column textAlign="right" mobile={16} tablet={5} computer={4}>
                    {
                      isEditBookingPayment && !this.props.disabled ? (
                        <Button
                          className="payment-save"
                          fluid
                          onClick={this.handleSaveBookingPayment}
                          color="blue"
                          content={t('Save', { ns: TRANSLATION_FILES.translation })}
                        />
                      ) : null
                    }
                  </Grid.Column>
                </Grid>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={8} computer={8}>
                {this.renderPaymentSection()}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Segment>
      </div>
    );
  }
}

export default withTranslation([...namespaces, TRANSLATION_FILES.models.booking])(connect(BookingPayment.mapStateToProps)(BookingPayment));



// WEBPACK FOOTER //
// ./src/containers/BookingPayment/BookingPayment.jsx